import React, { useEffect } from "react";
import { Route, BrowserRouter as Router, Routes } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";
import favicon from "./assets/fav.png"; // Adjust the path as necessary

// Importing pages
import About from "./pages/About";
import Contact from "./pages/Contact";
import Main from "./pages/Main";
import NotFound from "./pages/NotFound"; // Import the NotFound component
import Terms from "./pages/Terms";
import Privacy from "./pages/Privacy";

// Importing components
import Header from "./components/Header";
import Navigation from "./components/Navigation"; // <-- new navigation

function App() {
  useEffect(() => {
    document.title = "Emerging Evidence";
  }, []); // runs only once on mount

  useEffect(() => {
    const link = document.querySelector("link[rel~='icon']");
    if (!link) {
      const head = document.getElementsByTagName("head")[0];
      const newLink = document.createElement("link");
      newLink.rel = "icon";
      head.appendChild(newLink);
      newLink.href = favicon;
    } else {
      link.href = favicon;
    }
  }, []);

  // Prevent mobile browser address bar from hiding on scroll
  useEffect(() => {
    // Set CSS custom property for viewport height to account for address bar
    const setViewportHeight = () => {
      const vh = window.innerHeight * 0.01;
      document.documentElement.style.setProperty('--vh', `${vh}px`);
    };

    setViewportHeight();
    window.addEventListener('resize', setViewportHeight);
    window.addEventListener('orientationchange', setViewportHeight);

    return () => {
      window.removeEventListener('resize', setViewportHeight);
      window.removeEventListener('orientationchange', setViewportHeight);
    };
  }, []);

  return (
    <HelmetProvider>
      <Router>
        <Routes>
          <Route path="/" element={<Main />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/about" element={<About />} />
          <Route path="/terms" element={<Terms />} />
          <Route path="/privacy" element={<Privacy />} />
          <Route path="*" element={<NotFound />} />
        </Routes>
        <Header />
        <Navigation />
      </Router>
    </HelmetProvider>
  );
}

export default App;
